var render = function render(){
  var _vm$form$detail_plan, _vm$form$detail_plan2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.form ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-end mb-3"
  }, [!_vm.hasAnyRowEditing ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addRowDetail
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Detail Shipment ")]) : [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('submit');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Save Update ")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.cancelUpdate
    }
  }, [_vm._v(" Cancel Update ")])]], 2), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-bordered table-fixed-header"
  }, [_c('thead', {
    staticClass: "thead-light sticky-header"
  }, [_c('tr', [!_vm.isDetail ? _c('th', {
    staticClass: "text-truncate text-center align-middle column-1",
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('b-form-checkbox')], 1) : _vm._e(), !_vm.isDetail ? _c('th', {
    staticClass: "column-2 text-center align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-alt text-danger cursor-pointer",
    on: {
      "click": _vm.deleteAll
    }
  })]) : _vm._e(), _vm.isDetail ? _c('th', {
    staticClass: "text-center align-middle column-1",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.allRowsEditing ? 'fa-trash-alt text-danger' : 'fa-edit text-primary',
    attrs: {
      "title": _vm.allRowsEditing ? 'Delete All Rows' : 'Edit Semua Baris'
    },
    on: {
      "click": function click($event) {
        _vm.allRowsEditing ? _vm.deleteAll() : _vm.toggleAllRowsEdit();
      }
    }
  })]) : _vm._e(), _c('th', {
    staticClass: "text-truncate align-middle",
    class: _vm.isDetail ? 'column-number-detail' : 'column-number-edit',
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Number Detail Plan")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": 3
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Fleet")])]), _vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7)]), _vm._m(8)]), (_vm$form$detail_plan = _vm.form.detail_plan) !== null && _vm$form$detail_plan !== void 0 && _vm$form$detail_plan.length ? _c('tbody', {
    staticClass: "scrollable-body"
  }, _vm._l(_vm.form.detail_plan, function (state, index) {
    var _vm$fleetOptions$find, _vm$fleetOptions$find2, _vm$optionsCargoType$, _vm$optionsProjectTer;
    return _c('tr', {
      key: index
    }, [_vm.isDetail ? _c('td', {
      staticClass: "text-center align-center column-1 bg-white"
    }, [state !== null && state !== void 0 && state.can_delete ? [_c('i', {
      staticClass: "fa",
      class: _vm.isRowEditing(index) ? 'fa-trash-alt text-danger' : 'fa-edit text-primary',
      attrs: {
        "title": _vm.isRowEditing(index) ? 'Delete Row' : 'Edit Row'
      },
      on: {
        "click": function click($event) {
          _vm.isRowEditing(index) ? _vm.deleteRow(index) : _vm.startRowEdit(index);
        }
      }
    })] : [(_vm.isRowEditing(index) ? false : true) ? _c('i', {
      staticClass: "fa fa-edit text-primary",
      attrs: {
        "title": 'Edit Row'
      },
      on: {
        "click": function click($event) {
          return _vm.startRowEdit(index);
        }
      }
    }) : _vm._e()]], 2) : _vm._e(), !_vm.isDetail ? _c('td', {
      staticClass: "text-center align-center column-1 bg-white"
    }, [_c('b-form-checkbox', {
      attrs: {
        "type": "checkbox"
      }
    })], 1) : _vm._e(), !_vm.isDetail ? _c('td', {
      staticClass: "text-center align-center column-2 bg-white"
    }, [_c('i', {
      staticClass: "fa fa-trash-alt text-danger cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteRow(index);
        }
      }
    })]) : _vm._e(), _c('td', {
      staticClass: "text-truncate bg-white",
      class: _vm.isDetail ? 'column-number-detail' : 'column-number-edit',
      staticStyle: {
        "min-width": "300px"
      }
    }, [_vm.isDetail ? [_c('span', {
      staticClass: "form-control-plaintext d-inline-block"
    }, [_vm._v(" " + _vm._s(_vm.generateShipmentPlanNumber(_vm.form, state, index)) + " ")])] : [_vm._v(" " + _vm._s(_vm.generateShipmentPlanNumber(_vm.form, state, index)) + " ")]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('b-form-select', {
      staticClass: "form-control",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "name": "fleet_ownership"
      },
      model: {
        value: state.fleet_ownership,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_ownership", $$v);
        },
        expression: "state.fleet_ownership"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select ownership...")]), _c('option', {
      attrs: {
        "value": "own-ship"
      }
    }, [_vm._v("OWN SHIP")]), _c('option', {
      attrs: {
        "value": "chartered"
      }
    }, [_vm._v("CHARTERED")])])] : [_vm.isRowEditing(index) ? [_c('b-form-select', {
      staticClass: "form-control d-inline-block",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": ""
      },
      model: {
        value: state.fleet_ownership,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_ownership", $$v);
        },
        expression: "state.fleet_ownership"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select ownership...")]), _c('option', {
      attrs: {
        "value": "own-ship"
      }
    }, [_vm._v("OWN SHIP")]), _c('option', {
      attrs: {
        "value": "chartered"
      }
    }, [_vm._v("CHARTERED")])])] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.fleet_ownership === 'own-ship' ? 'OWN SHIP' : state.fleet_ownership === 'chartered' ? 'CHARTERED' : state.fleet_ownership || '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('SearchableSelect', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "options": _vm.filteredFleetOptions,
        "value-field": "value",
        "text-field": "text",
        "disabled": !_vm.hasSelectedFleetTypes,
        "placeholder": "Select fleet..."
      },
      model: {
        value: state.fleet_id,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_id", $$v);
        },
        expression: "state.fleet_id"
      }
    })] : [_vm.isRowEditing(index) ? [_c('SearchableSelect', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "options": _vm.filteredFleetOptions,
        "value-field": "value",
        "text-field": "text",
        "placeholder": "Select fleet..."
      },
      model: {
        value: state.fleet_id,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_id", $$v);
        },
        expression: "state.fleet_id"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$fleetOptions$find = _vm.fleetOptions.find(function (opt) {
      return opt.value === state.fleet_id;
    })) === null || _vm$fleetOptions$find === void 0 ? void 0 : _vm$fleetOptions$find.text) || state.fleet_id || '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('SearchableSelect', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "options": _vm.filteredFleetOptions,
        "value-field": "value",
        "text-field": "text",
        "disabled": !_vm.hasSelectedFleetTypes,
        "placeholder": "Select fleet..."
      },
      model: {
        value: state.second_fleet_id,
        callback: function callback($$v) {
          _vm.$set(state, "second_fleet_id", $$v);
        },
        expression: "state.second_fleet_id"
      }
    })] : [_vm.isRowEditing(index) ? [_c('SearchableSelect', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "options": _vm.filteredFleetOptions,
        "value-field": "value",
        "text-field": "text",
        "placeholder": "Select fleet..."
      },
      model: {
        value: state.second_fleet_id,
        callback: function callback($$v) {
          _vm.$set(state, "second_fleet_id", $$v);
        },
        expression: "state.second_fleet_id"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$fleetOptions$find2 = _vm.fleetOptions.find(function (opt) {
      return opt.value === state.second_fleet_id;
    })) === null || _vm$fleetOptions$find2 === void 0 ? void 0 : _vm$fleetOptions$find2.text) || state.second_fleet_id || '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "name": "cargo_type_id",
        "options": _vm.optionsCargoType,
        "value-field": "value",
        "text-field": "text",
        "plain": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v(" Select Cargo Type... ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.cargo_type_id,
        callback: function callback($$v) {
          _vm.$set(state, "cargo_type_id", $$v);
        },
        expression: "state.cargo_type_id"
      }
    })] : [_vm.isRowEditing(index) ? [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "name": "cargo_type_id",
        "options": _vm.optionsCargoType,
        "value-field": "value",
        "text-field": "text",
        "plain": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v(" Select Cargo Type... ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.cargo_type_id,
        callback: function callback($$v) {
          _vm.$set(state, "cargo_type_id", $$v);
        },
        expression: "state.cargo_type_id"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$optionsCargoType$ = _vm.optionsCargoType.find(function (opt) {
      return opt.value === state.cargo_type_id;
    })) === null || _vm$optionsCargoType$ === void 0 ? void 0 : _vm$optionsCargoType$.text) || state.cargo_type_id || '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('date-picker', {
      staticClass: "custom-date-picker",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm",
        "type": "datetime",
        "placeholder": "Select date",
        "format": "DD-MM-YYYY HH:mm"
      },
      model: {
        value: state.acceptance_date,
        callback: function callback($$v) {
          _vm.$set(state, "acceptance_date", $$v);
        },
        expression: "state.acceptance_date"
      }
    })] : [_vm.isRowEditing(index) ? [_c('date-picker', {
      staticClass: "custom-date-picker",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm",
        "type": "datetime",
        "placeholder": "Select date",
        "format": "DD-MM-YYYY HH:mm"
      },
      model: {
        value: state.acceptance_date,
        callback: function callback($$v) {
          _vm.$set(state, "acceptance_date", $$v);
        },
        expression: "state.acceptance_date"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.acceptance_date ? _vm.moment(state.acceptance_date).format('DD MMM YYYY HH:mm') : '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-form-select', {
      staticClass: "mr-2",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "plain": "",
        "size": "sm",
        "options": _vm.optionsProjectTerms
      },
      model: {
        value: state.terms_id,
        callback: function callback($$v) {
          _vm.$set(state, "terms_id", $$v);
        },
        expression: "state.terms_id"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Select Term ")])], 1), _c('b-form-input', {
      staticStyle: {
        "width": "240px"
      },
      attrs: {
        "rows": "2",
        "placeholder": "Text Type"
      },
      model: {
        value: state.terms_remarks,
        callback: function callback($$v) {
          _vm.$set(state, "terms_remarks", $$v);
        },
        expression: "state.terms_remarks"
      }
    })], 1)] : [_vm.isRowEditing(index) ? [_c('div', {
      staticClass: "d-inline-flex align-items-center"
    }, [_c('b-form-select', {
      staticClass: "mr-2",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "plain": "",
        "size": "sm",
        "options": _vm.optionsProjectTerms
      },
      model: {
        value: state.terms_id,
        callback: function callback($$v) {
          _vm.$set(state, "terms_id", $$v);
        },
        expression: "state.terms_id"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Select Term ")])], 1), _c('b-form-input', {
      staticStyle: {
        "width": "240px"
      },
      attrs: {
        "rows": "2",
        "placeholder": "Text Type"
      },
      model: {
        value: state.terms_remarks,
        callback: function callback($$v) {
          _vm.$set(state, "terms_remarks", $$v);
        },
        expression: "state.terms_remarks"
      }
    })], 1)] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$optionsProjectTer = _vm.optionsProjectTerms.find(function (opt) {
      return opt.value === state.terms_id;
    })) === null || _vm$optionsProjectTer === void 0 ? void 0 : _vm$optionsProjectTer.text) || state.terms_id || '-') + " " + _vm._s(state.terms_remarks ? ' - ' + state.terms_remarks : '') + " ")])]]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail ? [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "size": "sm"
      },
      model: {
        value: state.draught_type,
        callback: function callback($$v) {
          _vm.$set(state, "draught_type", $$v);
        },
        expression: "state.draught_type"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_loading"
      }
    }, [_vm._v(" Draught Survey Loading ")]), _c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_discharge"
      }
    }, [_vm._v(" Draught Survey Discharge ")])], 1)] : [_vm.isRowEditing(index) ? [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "size": "sm"
      },
      model: {
        value: state.draught_type,
        callback: function callback($$v) {
          _vm.$set(state, "draught_type", $$v);
        },
        expression: "state.draught_type"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_loading"
      }
    }, [_vm._v(" Draught Survey Loading ")]), _c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_discharge"
      }
    }, [_vm._v(" Draught Survey Discharge ")])], 1)] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.draught_type === 'draught_survey_loading' ? 'Draught Survey Loading' : state.draught_type === 'draught_survey_discharge' ? 'Draught Survey Discharge' : state.draught_type || '-') + " ")])]]], 2), _c('td', {
      staticClass: "text-left align-top"
    }, _vm._l(state.pol, function (statePol, i) {
      var _state$pol, _vm$positionListTextP;
      return _c('div', {
        key: i,
        staticClass: "d-flex align-items-start",
        class: {
          'mb-2': ((_state$pol = state.pol) === null || _state$pol === void 0 ? void 0 : _state$pol.length) > 1
        },
        staticStyle: {
          "width": "240px"
        }
      }, [_c('div', {
        staticClass: "w-100 mr-2"
      }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('b-form-select', {
        staticClass: "bg-white w-100",
        attrs: {
          "options": _vm.positionListTextPOL,
          "value-field": "value",
          "text-field": "text",
          "plain": ""
        },
        scopedSlots: _vm._u([{
          key: "first",
          fn: function fn() {
            return [_c('b-form-select-option', {
              attrs: {
                "value": null
              }
            }, [_vm._v(" Select POL... ")])];
          },
          proxy: true
        }], null, true),
        model: {
          value: statePol.value,
          callback: function callback($$v) {
            _vm.$set(statePol, "value", $$v);
          },
          expression: "statePol.value"
        }
      }), statePol.value == 'other' ? _c('b-form-input', {
        staticClass: "mt-1",
        attrs: {
          "type": "text",
          "placeholder": "Other pol..."
        },
        model: {
          value: statePol.valueOther,
          callback: function callback($$v) {
            _vm.$set(statePol, "valueOther", $$v);
          },
          expression: "statePol.valueOther"
        }
      }) : _vm._e()] : [_c('span', {
        staticClass: "form-control-plaintext"
      }, [_vm._v(" " + _vm._s(((_vm$positionListTextP = _vm.positionListTextPOL.find(function (opt) {
        return opt.value === statePol.value;
      })) === null || _vm$positionListTextP === void 0 ? void 0 : _vm$positionListTextP.text) || (statePol.value === 'other' ? statePol.valueOther : statePol.value) || '-') + " ")])]], 2), i == 0 && (!_vm.isDetail || _vm.isRowEditing(index)) ? _c('i', {
        staticClass: "fa fa-plus rounded-circle border text-success border-success p-2 cursor-pointer",
        on: {
          "click": function click($event) {
            var _vm$form$ports$state$, _vm$form$ports$state$2;
            return state.pol.push({
              value: ((_vm$form$ports$state$ = _vm.form.ports[state.pol.length]) === null || _vm$form$ports$state$ === void 0 ? void 0 : _vm$form$ports$state$.pol) || '',
              valueOther: ((_vm$form$ports$state$2 = _vm.form.ports[state.pol.length]) === null || _vm$form$ports$state$2 === void 0 ? void 0 : _vm$form$ports$state$2.valueOther) || ''
            });
          }
        }
      }) : !_vm.isDetail || _vm.isRowEditing(index) ? _c('i', {
        staticClass: "fa fa-trash-alt rounded-circle border text-danger border-danger p-2 cursor-pointer",
        on: {
          "click": function click($event) {
            return state.pol.splice(i, 1);
          }
        }
      }) : _vm._e()]);
    }), 0), _c('td', {
      staticClass: "text-left align-top"
    }, _vm._l(state.pod, function (statePol, i) {
      var _state$pod, _vm$positionListTextP2;
      return _c('div', {
        key: i,
        staticClass: "d-flex align-items-start",
        class: {
          'mb-2': ((_state$pod = state.pod) === null || _state$pod === void 0 ? void 0 : _state$pod.length) > 1
        },
        staticStyle: {
          "width": "240px"
        }
      }, [_c('div', {
        staticClass: "w-100 mr-2"
      }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('b-form-select', {
        staticClass: "bg-white w-100",
        attrs: {
          "options": _vm.positionListTextPOD,
          "value-field": "value",
          "text-field": "text",
          "plain": ""
        },
        scopedSlots: _vm._u([{
          key: "first",
          fn: function fn() {
            return [_c('b-form-select-option', {
              attrs: {
                "value": null
              }
            }, [_vm._v(" Select POD... ")])];
          },
          proxy: true
        }], null, true),
        model: {
          value: statePol.value,
          callback: function callback($$v) {
            _vm.$set(statePol, "value", $$v);
          },
          expression: "statePol.value"
        }
      }), statePol.value == 'other' ? _c('b-form-input', {
        staticClass: "mt-1",
        attrs: {
          "type": "text",
          "placeholder": "Other pod..."
        },
        model: {
          value: statePol.valueOther,
          callback: function callback($$v) {
            _vm.$set(statePol, "valueOther", $$v);
          },
          expression: "statePol.valueOther"
        }
      }) : _vm._e()] : [_c('span', {
        staticClass: "form-control-plaintext"
      }, [_vm._v(" " + _vm._s(((_vm$positionListTextP2 = _vm.positionListTextPOD.find(function (opt) {
        return opt.value === statePol.value;
      })) === null || _vm$positionListTextP2 === void 0 ? void 0 : _vm$positionListTextP2.text) || (statePol.value === 'other' ? statePol.valueOther : statePol.value) || '-') + " ")])]], 2), i == 0 && (!_vm.isDetail || _vm.isRowEditing(index)) ? _c('i', {
        staticClass: "fa fa-plus rounded-circle border text-success border-success p-2 cursor-pointer",
        on: {
          "click": function click($event) {
            var _vm$form$ports$state$3, _vm$form$ports$state$4;
            return state.pod.push({
              value: ((_vm$form$ports$state$3 = _vm.form.ports[state.pod.length]) === null || _vm$form$ports$state$3 === void 0 ? void 0 : _vm$form$ports$state$3.pod) || '',
              valueOther: ((_vm$form$ports$state$4 = _vm.form.ports[state.pod.length]) === null || _vm$form$ports$state$4 === void 0 ? void 0 : _vm$form$ports$state$4.valueOther) || ''
            });
          }
        }
      }) : !_vm.isDetail || _vm.isRowEditing(index) ? _c('i', {
        staticClass: "fa fa-trash-alt rounded-circle border text-danger border-danger p-2 cursor-pointer",
        on: {
          "click": function click($event) {
            return state.pod.splice(i, 1);
          }
        }
      }) : _vm._e()]);
    }), 0), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "size": "sm"
      },
      model: {
        value: state.shipment,
        callback: function callback($$v) {
          _vm.$set(state, "shipment", $$v);
        },
        expression: "state.shipment"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(" SELECT MONTH ")]), _c('b-form-select-option', {
      attrs: {
        "value": "JANUARY"
      }
    }, [_vm._v(" JANUARI ")]), _c('b-form-select-option', {
      attrs: {
        "value": "FEBRUARI"
      }
    }, [_vm._v(" FEBRUARI ")]), _c('b-form-select-option', {
      attrs: {
        "value": "MARET"
      }
    }, [_vm._v(" MARET ")]), _c('b-form-select-option', {
      attrs: {
        "value": "APRIL"
      }
    }, [_vm._v(" APRIL ")]), _c('b-form-select-option', {
      attrs: {
        "value": "MEI"
      }
    }, [_vm._v("MEI")]), _c('b-form-select-option', {
      attrs: {
        "value": "JUNI"
      }
    }, [_vm._v("JUNI")]), _c('b-form-select-option', {
      attrs: {
        "value": "JULI"
      }
    }, [_vm._v("JULI")]), _c('b-form-select-option', {
      attrs: {
        "value": "AGUSTUS"
      }
    }, [_vm._v(" AGUSTUS ")]), _c('b-form-select-option', {
      attrs: {
        "value": "SEPTEMBER"
      }
    }, [_vm._v(" SEPTEMBER ")]), _c('b-form-select-option', {
      attrs: {
        "value": "OKTOBER"
      }
    }, [_vm._v(" OKTOBER ")]), _c('b-form-select-option', {
      attrs: {
        "value": "NOVEMBER"
      }
    }, [_vm._v(" NOVEMBER ")]), _c('b-form-select-option', {
      attrs: {
        "value": "DESEMBER"
      }
    }, [_vm._v(" DESEMBER ")])], 1)] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.shipment || '-') + " ")])]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "date",
        "id": "eta_pol",
        "size": "sm"
      },
      model: {
        value: state.eta_pol,
        callback: function callback($$v) {
          _vm.$set(state, "eta_pol", $$v);
        },
        expression: "state.eta_pol"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.eta_pol ? _vm.moment(state.eta_pol).format('DD MMM YYYY') : '-') + " ")])]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "date",
        "id": "eta_pod",
        "min": state.eta_pol || null,
        "disabled": !state.eta_pol,
        "size": "sm"
      },
      on: {
        "input": function input() {
          if (state.eta_pol && state.eta_pod && state.eta_pod < state.eta_pol) state.eta_pod = state.eta_pol;
        }
      },
      model: {
        value: state.eta_pod,
        callback: function callback($$v) {
          _vm.$set(state, "eta_pod", $$v);
        },
        expression: "state.eta_pod"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(state.eta_pod ? _vm.moment(state.eta_pod).format('DD MMM YYYY') : '-') + " ")])]], 2), _c('td', {
      staticClass: "text-left"
    }, [!_vm.isDetail || _vm.isRowEditing(index) ? [_c('InputCurrency', {
      attrs: {
        "id": "plan_quantity",
        "name": "plan_quantity",
        "prepend": "",
        "size": "sm",
        "placeholder": "0"
      },
      model: {
        value: state.plan_quantity,
        callback: function callback($$v) {
          _vm.$set(state, "plan_quantity", $$v);
        },
        expression: "state.plan_quantity"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext text-center"
    }, [_vm._v(" " + _vm._s(state.plan_quantity ? _vm.currencyFormat(state.plan_quantity) : '-') + " " + _vm._s(_vm.form.unit || '') + " ")])]], 2), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [[_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.openDescriptionModal(state, index);
        }
      }
    }, [_vm._v(" Descriptions ")])]], 2), _c('td', {
      staticClass: "text-left",
      attrs: {
        "align": "center"
      }
    }, [[_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.openRemarksModal(state, index);
        }
      }
    }, [_vm._v(" Remarks ")])]], 2)]);
  }), 0) : _vm._e()]), !((_vm$form$detail_plan2 = _vm.form.detail_plan) !== null && _vm$form$detail_plan2 !== void 0 && _vm$form$detail_plan2.length) ? _c('div', {
    staticClass: "px-3",
    staticStyle: {
      "position": "sticky",
      "left": "0"
    }
  }, [_vm._v(" No Data Detail Shipment Plan ")]) : _vm._e()]), _c('b-modal', {
    attrs: {
      "title": "Description",
      "ok-title": "Save",
      "cancel-title": "Cancel"
    },
    on: {
      "ok": _vm.saveDescription,
      "cancel": _vm.cancelModal
    },
    model: {
      value: _vm.showDescriptionModal,
      callback: function callback($$v) {
        _vm.showDescriptionModal = $$v;
      },
      expression: "showDescriptionModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Description",
      "label-for": "description-textarea"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description-textarea",
      "placeholder": "Type description here...",
      "rows": "5"
    },
    model: {
      value: _vm.tempDescription,
      callback: function callback($$v) {
        _vm.tempDescription = $$v;
      },
      expression: "tempDescription"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "title": "Remarks",
      "ok-title": "Save",
      "cancel-title": "Cancel"
    },
    on: {
      "ok": _vm.saveRemarks,
      "cancel": _vm.cancelModal
    },
    model: {
      value: _vm.showRemarksModal,
      callback: function callback($$v) {
        _vm.showRemarksModal = $$v;
      },
      expression: "showRemarksModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks",
      "label-for": "remarks-textarea"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "remarks-textarea",
      "placeholder": "Comments if any / Komentar jika ada...",
      "rows": "5"
    },
    model: {
      value: _vm.tempRemarks,
      callback: function callback($$v) {
        _vm.tempRemarks = $$v;
      },
      expression: "tempRemarks"
    }
  })], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Cargo Type")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Draught Type")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Location")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Shipment Month")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Plan Date")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Plan Quantity")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Description")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('th', {
    staticClass: "text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Remarks")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Ownership")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("First Fleet")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Second Fleet")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Type")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {}, [_c('span', {
    staticClass: "text-capitalize text-truncate"
  }, [_vm._v("Acc. Date")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Terms")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Port Of Loading")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Port Of Dhischarge")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("ETA POL")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("ETA POD")])])]);

}]

export { render, staticRenderFns }